export enum RobotAccountsEvent {
    ClickedRobotAccounts = 'Accounts.ClickedRobotAccounts',
    ClickedRobotAccountsUpgrade = 'Accounts.ClickedRobotAccountsUpgrade',
    ClickedRobotAccountsContact = 'Accounts.ClickedRobotAccountsContact',
    ClickedRobotAccountsDocs = 'Accounts.ClickedRobotAccountsDocs',
}
